/**
 * Created by Carsten Hibbeler on 08.02.2016.
 */
'use strict';

import L from 'external/leaflet';
import { AppContext, DataUtil } from 'plugin/liferay-widgets-react-web';
import { getBoundsFromGeometry } from 'plugin/map-portlet';
import { getFliwasOrganizationStore } from '../stores/StoreFactory';
import { STORE_KEY_CURRENT_ORGANIZATION } from '../constants/Constants';

const FliwasOrganizationStore = getFliwasOrganizationStore(AppContext);

export default class FliwasOrganizationDefaultPositionPlugin {

    init(map, o, reEvaluate) {
        this.reEvaluate = reEvaluate;
        this.removeListener = FliwasOrganizationStore.addListener(this.reEvaluate);

        this.bounds = this.getBounds(o);

        this.zoomToOrganizationControl = L.Control.extend({
            options: {
                position: 'topright'
            },
            onAdd: (map) => {
                let container = (map.zoomControl && map.zoomControl._container) || L.DomUtil.create('div', 'leaflet-bar');

                this.link = L.DomUtil.create('a', 'leaflet-control-default-position leaflet-bar-part', container);
                L.DomUtil.toBack(this.link);
                this.link.href = '#';
                this.link.setAttribute('role', 'button');
                this.link.setAttribute('title', 'Zurück zum Mandanten');
                this.link.setAttribute('aria-label', 'Zurück zum Mandanten');
                this.icon = L.DomUtil.create('span', 'fa fa-home', this.link);

                L.DomEvent.disableClickPropagation(container);
                L.DomEvent.on(this.link, 'click', L.DomEvent.stop);
                L.DomEvent.on(this.link, 'click', this.zoomToOrganization.bind(this, map), this);

                return container;

            }
        });
        this.control = new this.zoomToOrganizationControl();
        this.boundRequestHandled = false;
        this.boundRequestCb = this.boundRequestCb.bind(this);
        map.addControl(this.control);
    }

    initOptions(o) {
        this.bounds = this.getBounds(o);
        if (this.bounds && !this.boundRequestHandled) {
            o.boundRequest = {
                bounds: this.bounds,
                options: { animate: false },
                cb: this.boundRequestCb
            };
        }
        return o;
    }

    update(map, o) {
        const newBounds = this.getBounds(o);
        if (!this.bounds || (!this.bounds.equals(newBounds))) {
            this.bounds = this.getBounds(o);
            this.zoomToOrganization(map);
        }
    }

    getBounds(options) {
        // Portlet config overrides default behaviour. See FLIWASEN-45 https://inovum-dev.de/jira/browse/FLIWASEN-45
        if (options && options.portletConfig && options.portletConfig.boundingBox) {
            const bbox = options.portletConfig.boundingBox;
            return L.latLngBounds(L.latLng(bbox.latitudeMin, bbox.longitudeMin), L.latLng(bbox.latitudeMax, bbox.longitudeMax));
        } else {
            const currentOrganization = DataUtil.asItem(FliwasOrganizationStore.getRemoteData(STORE_KEY_CURRENT_ORGANIZATION));
            const boundingBox = currentOrganization && currentOrganization.boundingBox;
            if (boundingBox) {
                return L.latLngBounds(boundingBox.coordinates[ 0 ].map(point => L.latLng(point[ 1 ], point[ 0 ])));
            }

            const geometry = currentOrganization && currentOrganization.geometry;
            if (geometry) {
                return getBoundsFromGeometry(geometry);
            }
        }
        return null;
    }

    zoomToOrganization(map) {
        if (this.bounds) {
            map.fitBounds(this.bounds);
        }
    }

    remove() {
        if (this.removeListener) {
            this.removeListener.remove();
        }
    }

    boundRequestCb() {
        this.boundRequestHandled = true;
    }

}






// WEBPACK FOOTER //
// ./js/plugins/FliwasOrganizationDefaultPositionPlugin.js